import React from 'react';
import styled from 'styled-components';
import { ReportStatus } from '../../../../interface';

const LABELS: Record<ReportStatus, string> = {
  queued: 'Aguardando',
  processing: 'Em processamento',
  ready: 'Concluído',
  error: 'Erro',
};

function getColor(theme: any, status: ReportStatus): string {
  switch (status) {
    case 'queued':
      return theme.colors.pending;
    case 'processing':
      return theme.colors.blue;
    case 'ready':
      return theme.colors.active;
    case 'error':
      return theme.colors.red;
    default:
      return theme.colors.gray;
  }
}

interface PillProps {
  status: ReportStatus;
}

const Pill = styled.span<PillProps>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: ${(props) => props.theme.fontSize.small};
  font-weight: 700;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => getColor(props.theme, props.status)};
  white-space: nowrap;
`;

function StatusPill({ status }: PillProps) {
  return <Pill status={status}>{LABELS[status]}</Pill>;
}

export default StatusPill;
